"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trainingProviders = void 0;
const deepSeekModels = [
    { value: "deepseek-ai/DeepSeek-R1-Distill-Llama-70B", label: "DeepSeek R1 Distilled Llama 70B", description: "Higher latency,Best precision" },
    { value: "deepseek-ai/DeepSeek-R1-Distill-Qwen-14B", label: "DeepSeek R1 Distilled Qwen 14B", description: "Higher latency,Better precision,High frequency workload optimized" },
    { value: "deepseek-ai/DeepSeek-R1-Distill-Qwen-1.5B", label: "DeepSeek R1 Distilled Qwen 1.5B", description: "Lowest latency,Cheapest,High frequency workload optimized" }
];
const mistralModels = [
    { value: "mistralai/Mistral-7B-Instruct-v0.2", label: "Mistral 7B Instruct v0.2", description: "Instructions-focused,Better precision" },
    { value: "mistralai/Mistral-7B-v0.1", label: "Mistral 7B v0.1", description: "Good precision,Higher latency" },
    { value: "mistralai/Mixtral-8x7B-v0.1", label: "Mixtral 8x7B v0.1", description: "Mixture-of-Experts design,Good precision" }
];
const llamaModels = [
    { value: "meta-llama/Llama-3.3-70b-instruct-reference", label: "LLama 3.3 70B", description: "Instructions and referencing focus,Advanced fine-tuning" },
    { value: "meta-llama/Llama-3-70b-instruct", label: "LLama 3 70B", description: "Research optimized,Highest quality requirements,Advanced fine-tuning,Instruction focused" },
    { value: "meta-llama/Llama-3-8b-chat-hf", label: "LLama 3 8B", description: "Basic fine-tuning,Maximum accuracy requirements" }
];
exports.trainingProviders = [
    { name: "DeepSeek", value: "deepseek-ai", models: deepSeekModels },
    { name: "MistralAI", value: "mistalai", models: mistralModels },
    { name: "Meta AI", value: "meta-llama", models: llamaModels }
];
